// 生成下载配置：特殊维度全量/隐藏、组合与合并策略、级联开关等
// 生成下载配置：特殊维度全量/隐藏、组合与合并策略、级联开关等
import { useMemo } from 'react';
import { TXAxis } from '../../AIContent/_type';
import { DATE_OR_TIME_DATA_TYPE } from '../../../../config/constant';
import { IDownloadConfig } from '../types';

/**
 * 下载配置 Hook
 * 基于 xAxis/legends 自动生成配置，支持自定义扩展
 */
export const useDownloadConfig = (props: {
  xAxis: TXAxis;
  legends: any[];
  customConfig?: Partial<IDownloadConfig>;
}): IDownloadConfig => {
  const xAxisDateKeys = useMemo(() => {
    const keys: string[] = [];
    (props?.xAxis || []).forEach((item: any) => {
      if (typeof item === 'string') {
        keys.push(item);
      } else if (item && typeof item === 'object' && item.date_key) {
        keys.push(item.date_key);
      }
    });
    return keys.filter((key) => DATE_OR_TIME_DATA_TYPE.includes(key));
  }, [props.xAxis]);

  const legendKeys = useMemo(() => {
    const keys: string[] = [];
    (props?.legends || []).forEach((item: any) => {
      if (typeof item === 'string') {
        keys.push(item);
      } else if (item && typeof item === 'object' && item.data_key) {
        keys.push(item.data_key);
      }
    });
    return keys;
  }, [props.legends]);

  return useMemo(
    () => ({
      specialDimensions: {
        fullDownloadHidden: [...xAxisDateKeys, ...legendKeys],
        fullDownload: [...xAxisDateKeys, ...legendKeys],
      },
      combinationStrategy: 'cartesian',
      mergeStrategy: 'union',
      dataGeneration: {
        useRawData: true,
      },
      cascade: {
        enabled: true,
        autoSelectSingle: true,
      },
      ...props.customConfig,
    }),
    [xAxisDateKeys, legendKeys, props.customConfig]
  );
};

